import { render, staticRenderFns } from "./ClauseList.vue?vue&type=template&id=8625ecb8&scoped=true"
import script from "./ClauseList.vue?vue&type=script&lang=ts"
export * from "./ClauseList.vue?vue&type=script&lang=ts"
import style0 from "./ClauseList.vue?vue&type=style&index=0&id=8625ecb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8625ecb8",
  null
  
)

export default component.exports